import moment from "moment-timezone";

import {ServiceTypeInfo} from '../domain/ServiceTypeInfo';
import UNKNOWN from '../resources/image/unknown.png';
import {darkenColor, lightenColor} from './ColorUtils';

export const retrieveServiceTypeIcon = (keycodes) => {

    if (!Array.isArray(keycodes) || keycodes.length === 0) {
        return [UNKNOWN];
    }

    const uniqueKeycodes = [...new Set(keycodes.filter(Boolean))];

    if (uniqueKeycodes.length === 0) {
        return [UNKNOWN];
    }

    return uniqueKeycodes.map(keycode => {
        const serviceTypeInfo = ServiceTypeInfo.find(serviceType => serviceType.keycode === keycode);
        return serviceTypeInfo ? serviceTypeInfo.icon : UNKNOWN;
    });
};

export const buildServiceTypeDetails = (item) => {
    return item.serviceType
    .filter(serviceType =>
      moment(serviceType.startTime).isSameOrBefore(item.from) &&
      moment(serviceType.endTime).isSameOrAfter(item.to)
    )
    .map(serviceType => ({
        keycode: serviceType.keycode,
        primaryColor: serviceType.primaryColor,
        description: serviceType.description,
        isBookable: serviceType.isBookable
    }));
};

export const buildBookableServiceBookableSessionColor = (bookableService) => lightenColor(bookableService?.primaryColor);

export const buildBookableServiceLockedSessionColor = (bookableService) => darkenColor(bookableService?.primaryColor);